// @flow
import { get } from 'lodash';
import cookies from 'js-cookie';
import moment from 'moment';

import { initAppContext } from 'Context/initAppContext';
import { setLocale as setI18nLocale } from 'Src/i18n';

// Server-side the context is created everytime
// client-side, it's first saved in the constructor of _app, then retrieved in subsequent
// getInitialProps
let localAppContext;

// $FlowFixMe
export const getAppContext = (): AppContext => localAppContext;

export const saveAppContext = (appContext: AppContext) => {
  const data: AppContext = {
    ...appContext,
    cookies: cookies.get(),
    userAgent: get(window, 'navigator.userAgent'),
  };

  localAppContext = {
    ...data,
    ...initAppContext(data.originalUrl, data),
  };

  const momentLocale = get(
    localAppContext,
    `availableLocales.${localAppContext.locale}.moment`,
    'fr',
  );
  moment.locale(momentLocale);
  setI18nLocale(localAppContext.locale.slice(0, 2));

  return localAppContext;
};
